(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hyperdis", [], factory);
	else if(typeof exports === 'object')
		exports["hyperdis"] = factory();
	else
		root["hyperdis"] = factory();
})(window, function() {
return 